import { ADAPTATION_COLORS } from '~/constants'

type AdaptationIconProps = {
  adaptation: string | undefined
  className?: string
}

type BaseIconProps = {
  className?: string
}

const BRICKS = [
  [1, 2, 6],
  [8, 2, 6],
  [15, 2, 4],
  [4, 6, 6],
  [11, 6, 6],
  [1, 10, 6],
  [8, 10, 6],
  [15, 10, 4],
  [4, 14, 6],
  [11, 14, 6],
]

export function SeawallIcon({ className = 'h-5 w-5' }: BaseIconProps) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="none">
      {BRICKS.map(([x, y, width], idx) => (
        <rect
          key={`${x}-${y}-${idx}`}
          x={x}
          y={y}
          width={width}
          height="3"
          fill={ADAPTATION_COLORS.base}
          stroke={ADAPTATION_COLORS.outline}
          strokeWidth="0.5"
        />
      ))}
    </svg>
  )
}

export function ReefIcon({ className = 'h-5 w-5' }: BaseIconProps) {
  const blocks = [
    [1.5, 3.5],
    [7.5, 3.5],
    [13.5, 3.5],
    [4.5, 7.5],
    [10.5, 7.5],
    [1.5, 11.5],
    [7.5, 11.5],
    [13.5, 11.5],
  ]

  return (
    <svg className={className} viewBox="0 0 20 20" fill="none">
      {blocks.map(([x, y], idx) => (
        <rect
          key={`${x}-${y}-${idx}`}
          x={x}
          y={y}
          width="4"
          height="4"
          rx="0.9"
          fill={ADAPTATION_COLORS.base}
          stroke={ADAPTATION_COLORS.outline}
          strokeWidth="0.5"
        />
      ))}
    </svg>
  )
}

export function DuneIcon({ className = 'h-5 w-5 mb-1' }: BaseIconProps) {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="none">
      <path
        d="M1.5 13.4C4.4 13.4 5.4 7.8 9.6 7.8C13.8 7.8 14.8 12 18.5 12V17.5H1.5V13.4Z"
        fill={ADAPTATION_COLORS.base}
        stroke={ADAPTATION_COLORS.outline}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M4.9 12.2C6.3 11.2 7.2 9.4 9.3 9.4C11.2 9.4 12.2 10.5 14 10.8"
        stroke={ADAPTATION_COLORS.detail}
        strokeWidth="0.6"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function AdaptationIcon({ adaptation, className }: AdaptationIconProps) {
  switch (adaptation) {
    case '014':
    case 'seawall':
      return <SeawallIcon className={className} />
    case '023':
    case 'reef':
      return <ReefIcon className={className} />
    case '031':
    case 'dune':
      return <DuneIcon className={className} />
    default:
      return null
  }
}
